import { RouterProvider } from 'react-router-dom';
import router from './routes';
import Locales from './components/Locales';

function App() {
  return (
    <Locales>
      <RouterProvider router={router} />
    </Locales>
  );
}

export default App;
